import { render, staticRenderFns } from "./RelatedResources.vue?vue&type=template&id=90b2a312&scoped=true"
import script from "./RelatedResources.vue?vue&type=script&lang=js"
export * from "./RelatedResources.vue?vue&type=script&lang=js"
import style0 from "./RelatedResources.vue?vue&type=style&index=0&id=90b2a312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b2a312",
  null
  
)

export default component.exports